var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSparrowDeleteButton = function SvgSparrowDeleteButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "sparrow-delete-button",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "sparrow-delete-button-back",
    fill: "none",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "sparrow-delete-button-highlight",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "sparrow-delete-button-front",
    cx: 12,
    cy: 12,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "sparrow-delete-icon",
    fill: "#FFF",
    d: "m13.255 12 2.236-2.236a.223.223 0 0 0 0-.313l-.942-.942a.223.223 0 0 0-.313 0L12 10.745 9.765 8.509a.223.223 0 0 0-.314 0l-.942.942a.221.221 0 0 0 0 .313L10.745 12l-2.236 2.236a.221.221 0 0 0 0 .313l.942.942a.223.223 0 0 0 .314 0L12 13.255l2.236 2.236a.223.223 0 0 0 .313 0l.942-.942a.223.223 0 0 0 0-.313L13.255 12Z"
  }))));
};

export default SvgSparrowDeleteButton;